import { createContext } from 'react';
import { WorkspaceTabs } from './WorkspaceV2';

export type WorkspaceTabsContextType = {
  currentTab: WorkspaceTabs;
  setCurrentTab: (tab: WorkspaceTabs) => void;
  isReadyForExport: boolean;
  setIsReadyForExport: (isReady: boolean) => void;
};
export const WorkspaceTabsContext = createContext<WorkspaceTabsContextType>(
  {} as any,
);
